/**
 * Source-attribution string for the eligibility detail blocks.
 * Renders only when a source is present (i.e. a check has actually run);
 * the specific provider name is intentionally not surfaced.
 */
export function formatSourceProvenance(
  source: string | null | undefined,
): string | null {
  if (!source) return null;
  return 'From insurance check';
}
